import React from "react";
import classNames from "classnames";
import StepCompleteIcon from "./images/step-complete-icon.svg";
import StepIcon from "./images/step-icon.svg";

type StepperProps = {
  steps: number;
  currentStep?: number;
};

export const Stepper = ({ steps, currentStep = 0 }: StepperProps) => {
  const stepsArr = Array.from({ length: steps }, () => "step");
  const currentStepIdx = currentStep - 1;

  return (
    <div className="flex justify-center items-center max-w-[707px] mx-auto">
      {stepsArr.map((_, idx, arr) => (
        <div
          key={idx}
          className={classNames({ "flex-1": idx < arr.length - 1 })}
        >
          <div className="flex items-center">
            <div>
              {idx <= currentStepIdx ? <StepCompleteIcon /> : <StepIcon />}
            </div>

            {idx < arr.length - 1 && (
              <div className="flex items-center flex-1 h-1">
                <div
                  className={classNames("h-full", {
                    "bg-green-500 h-2 rounded-l-[5px]": idx <= currentStepIdx,
                    "bg-gray-200": idx > currentStepIdx,
                  })}
                  style={{ width: "50%" }}
                ></div>

                <div
                  className={classNames("h-full", {
                    "bg-green-500 h-2": idx + 1 <= currentStepIdx,
                    "bg-gray-200": idx + 1 !== currentStepIdx,
                  })}
                  style={{ width: "50%" }}
                ></div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
